// src/utils/debug.ts
// Development-only logging. No-ops in production builds so debug output (and any
// PII it might carry) never reaches the browser console for real users.
// Use `debug(...)` in place of `console.log(...)` for diagnostic output.

const enabled = Boolean(import.meta.env?.DEV);

export function debug(...args: unknown[]): void {
  if (enabled) console.log(...args);
}

export function debugWarn(...args: unknown[]): void {
  if (enabled) console.warn(...args);
}
